// assets/size-modal.js
// Thin wrapper which configures the generic factory for the PILLOW-CASE selector.
// (The heavy-lifting now lives in `size-modal-factory.js` so we avoid duplication.)

(function(){
  if (!window.SilonSizeModalFactory){
    console.error('[size-modal] Expected `SilonSizeModalFactory` to be available before this script is executed.');
    return;
  }
  
    const productSizes = {
      'white': {
        'classic':      { id: '51567186903376', surcharge: 0 },
        'comfort':      { id: '51567186936144', surcharge: 0 },
        'comfortplus':  { id: '51567186870608', surcharge: 0 },
        'square':       { id: '51567186968912', surcharge: 0 },
        'royal-square': { id: '51567187001680', surcharge: 12 },
        'king/queen':   { id: '51567187034448', surcharge: 8 }
      },
      'black': {
        'classic':      { id: '49810182013264', surcharge: 0 },
        'comfort':      { id: '49810182078800', surcharge: 0 },
        'comfortplus':  { id: '49810182046032', surcharge: 0 },
        'square':       { id: '51292503474512', surcharge: 0 },
        'royal-square': { id: '51292503507280', surcharge: 12 },
        'king/queen':   { id: '51292503540048', surcharge: 8 }
      },
      'silver': {
        'classic':      { id: '49810214945104', surcharge: 0 },
        'comfort':      { id: '49810215010640', surcharge: 0 },
        'comfortplus':  { id: '49810214977872', surcharge: 0 },
        'square':       { id: '51292496462160', surcharge: 0 },
        'royal-square': { id: '51292496494928', surcharge: 12 },
        'king/queen':   { id: '51292496527696', surcharge: 8 }
      },
      'blue': {
        'classic':      { id: '51293167255888', surcharge: 0 },
        'comfort':      { id: '51293167321424', surcharge: 0 },
        'comfortplus':  { id: '51293167288656', surcharge: 0 },
        'square':       { id: '51293167354192', surcharge: 0 },
        'royal-square': { id: '51293167386960', surcharge: 12 },
        'king/queen':   { id: '51293167419728', surcharge: 8 }
      },
      'champagne': {
        'classic':      { id: '49810218615120', surcharge: 0 },
        'comfort':      { id: '49810218680656', surcharge: 0 },
        'comfortplus':  { id: '49810218647888', surcharge: 0 },
        'square':       { id: '51292503179600', surcharge: 0 },
        'royal-square': { id: '51292503212368', surcharge: 12 },
        'king/queen':   { id: '51292503245136', surcharge: 8 }
      },
      'red': {
        'classic':      { id: '49810223235408', surcharge: 0 },
        'comfort':      { id: '49810223300944', surcharge: 0 },
        'comfortplus':  { id: '49810223268176', surcharge: 0 },
        'square':       { id: '51292503048528', surcharge: 0 },
        'royal-square': { id: '51292503081296', surcharge: 12 },
        'king/queen':   { id: '51292503114064', surcharge: 8 }
      },
      'gold': {
        'classic':      { id: '49810225922384', surcharge: 0 },
        'comfort':      { id: '49810225987920', surcharge: 0 },
        'comfortplus':  { id: '49810225955152', surcharge: 0 },
        'square':       { id: '51292502950224', surcharge: 0 },
        'royal-square': { id: '51292502982992', surcharge: 12 },
        'king/queen':   { id: '51292503015760', surcharge: 8 }
      },
      'coral': {
        'classic':      { id: '49810228543824', surcharge: 0 },
        'comfort':      { id: '49810228609360', surcharge: 0 },
        'comfortplus':  { id: '49810228576592', surcharge: 0 },
        'square':       { id: '51292502851920', surcharge: 0 },
        'royal-square': { id: '51292502884688', surcharge: 12 },
        'king/queen':   { id: '51292502917456', surcharge: 8 }
      },
      'pink': {
        'classic':      { id: '49810213241168', surcharge: 0 },
        'comfort':      { id: '49810213306704', surcharge: 0 },
        'comfortplus':  { id: '49810213273936', surcharge: 0 },
        'square':       { id: '51292491350352', surcharge: 0 },
        'royal-square': { id: '51292491383120', surcharge: 12 },
        'king/queen':   { id: '51292491415888', surcharge: 8 }
      }
    };

  window.SilonSizeModal = window.SilonSizeModalFactory({
    overlayId: 'size-modal',
    productSizes,
    colorBased: true,
    defaultSize: 'comfortplus'
  });
  })();
  